import React from 'react';
import PropTypes from 'prop-types';
import AudioPlayer from 'generic/AudioPlayer/AudioPlayer.react';
import constants from 'client/constants';
import {AuthoringSupplementModelV1} from 'resources/augmented/AuthoringSupplement/AuthoringSupplementModel.v1';
import {SupplementModelV1} from 'resources/augmented/Supplement/SupplementModel.v1';

import './audio.scss';

export default class Audio extends React.Component {
  static propTypes = {
    supplement: PropTypes.oneOfType([
      PropTypes.instanceOf(AuthoringSupplementModelV1),
      PropTypes.instanceOf(SupplementModelV1)
    ])
  };

  render() {
    const content = this.props.supplement.getContent();
    const audioFile = content.get('audio');

    if (!audioFile) {
      return null;
    }

    return (
      <div className='audio-supplement-wrapper'>
        <AudioPlayer
          caption={this.props.supplement.getCaption()}
          src={constants.CDN_ASSETS_HOST + '/' + audioFile}
          inline={content.get('inline')}
        />
      </div>
    );
  }
}
